export default __webpack_public_path__ + "../staticImages/sprite-vinos-store-de-2x.png";